import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const Home = () => {
  return (
    <div className="home page-transition">
      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <div className="hero-content">
            <h1 className="hero-title">
              Professional Consulting Services for Your Business Growth
            </h1>
            <p className="hero-subtitle">
              Expert business consulting and strategic advisory services to help your company thrive in today's competitive market.
            </p>
            <div className="hero-buttons">
              <Link to="/contact#book-appointment-form" className="btn btn-contrast">
                Book Appointment
              </Link>
              <Link to="/about" className="btn btn-white-red">
                Learn More
              </Link>
            </div>
          </div>
        </div>
        <div className="hero-background"></div>
      </section>

      {/* Features Section */}
      <section className="section features">
        <div className="container">
          <div className="section-header text-center">
            <h2>Why Choose ProsperityPartners?</h2>
            <p>We provide comprehensive consulting solutions tailored to your business needs</p>
          </div>
          
          <div className="grid grid-3">
            <div className="feature-card">
              <div className="feature-icon">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M9 12l2 2 4-4"></path>
                  <path d="M21 12c0 4.97-4.03 9-9 9s-9-4.03-9-9 4.03-9 9-9 9 4.03 9 9z"></path>
                </svg>
              </div>
              <h3>Trustworthy</h3>
              <p>Receive expert advice on best practices and financial efficiencies you can implement immediately.</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"></path>
                </svg>
              </div>
              <h3>Experienced</h3>
              <p>Rely on our team of multi-industry experts with years of proven consulting experience.</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"></path>
                </svg>
              </div>
              <h3>Efficient</h3>
              <p>Streamline your operations through accurate and efficient management of your business processes.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="section services">
        <div className="container">
          <div className="section-header text-center">
            <h2>Our Consulting Services</h2>
            <p>Comprehensive solutions designed to drive your business forward</p>
          </div>
          
          <div className="grid grid-2">
            <div className="service-card">
              <div className="service-content">
                <h3>Strategic Planning</h3>
                <p>Develop comprehensive business strategies that align with your goals and market opportunities.</p>
                <Link to="/contact#book-appointment-form" className="service-link">Learn more →</Link>
              </div>
            </div>
            
            <div className="service-card">
              <div className="service-content">
                <h3>Business Development</h3>
                <p>Identify new market opportunities and develop strategies to expand your business reach.</p>
                <Link to="/contact#book-appointment-form" className="service-link">Learn more →</Link>
              </div>
            </div>
            
            <div className="service-card">
              <div className="service-content">
                <h3>Financial Advisory</h3>
                <p>Expert financial guidance to optimize your business performance and profitability.</p>
                <Link to="/contact#book-appointment-form" className="service-link">Learn more →</Link>
              </div>
            </div>
            
            <div className="service-card">
              <div className="service-content">
                <h3>Operational Excellence</h3>
                <p>Streamline your operations and improve efficiency across all aspects of your business.</p>
                <Link to="/contact#book-appointment-form" className="service-link">Learn more →</Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section cta-section">
        <div className="container">
          <div className="cta-content text-center">
            <h2>Ready to Transform Your Business?</h2>
            <p>Let's discuss how we can help you achieve your business goals and drive sustainable growth.</p>
            <Link to="/contact#book-appointment-form" className="btn btn-primary btn-large">
              Schedule Your Consultation
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home; 